import React from "react";
import "../styles/project.css";

const Homegaurd = () => {
  return (
    <div className="project-content">
      <h3>Homegaurd</h3>
      <a
            href="https://www.kaggle.com/code/dhruvgupta37/homegaurd"
            target="_blank"
          >
            SourceCode
          </a>
      <h3>Technologies used</h3>
      Python, Scikit-learn, Matplotlib, Seaborn
      <h3>What is this?</h3>
      <li>
        Implemented a machine learning model using Python, Scikit-learn,
        Matplotlib, and Seaborn for the "Home Guard" project.
      </li>
      <li>
        The model is trained to detect the presence of an intruder in a house
        based on CO2 levels, humidity, and sound instead of light.
      </li>
      <li>
        The focus on non-traditional indicators enhances security measures for
        homeowners.
      </li>
    </div>
  );
};

export default Homegaurd;
